module.exports = __webpack_public_path__ + "img/598d2c55bd916261.png";